export default __webpack_public_path__ + "static/media/heavenpic2.a6206c6e.jpg";